import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RouterService } from 'src/app/core/router.service';

@Component({
    selector: 'pk-broker-advisor-academy-tour-modal',
    templateUrl: './advisor-academy-tour-modal.component.html',
    styleUrl: './advisor-academy-tour-modal.component.scss',
    standalone: false
})
export class AdvisorAcademyTourModalComponent {
	// inputs
	public tourModalState: { dontShowAgainCheck: boolean };

	public featureTour = {
		slides: [
			{
				imgSrc: 'https://assets.powerkiosk.com/includes/tours/advisor-academy-2025-03/slide01.jpg',
				name: 'Slide 1',
				caption: 'Unlock your full potential with the Advisor Academy eLearning modules.',
			},
			{
				imgSrc: 'https://assets.powerkiosk.com/includes/tours/advisor-academy-2025-03/slide02.jpg',
				name: 'Slide 2',
				caption: 'Access expert training on sales, energy, and the platform to boost your skills and drive results.',
			},
			{
				imgSrc: 'https://assets.powerkiosk.com/includes/tours/advisor-academy-2025-03/slide03.jpg',
				name: 'Slide 3',
				caption: 'Start Learning Today.',
			},
		],
	};

	public activeIndex = 0;

	constructor(
		private activeModal: BsModalRef,
		private routerService: RouterService,
	) { }

	public close(): void {
		this.activeModal.hide();
	}

	public async goToAdvisorAcademy(): Promise<void> {
		await this.routerService.navigate(['/academy']);
		this.close();
	}

	public next(): void {
		this.activeIndex++;
		if (this.activeIndex >= 3) {
			this.activeIndex = 0;
		}
	}

	public previous(): void {
		this.activeIndex--;
		if (this.activeIndex < 0) {
			this.activeIndex = 3 - 1;
		}
	}
}
